import { numbersFormatter } from "./number";

export { toDate, toPersianTimeString, dayTitle };

function toPersianTimeString(timeString) {
  let [hours, minutes, _seconds] = timeString.split(":");

  return `${numbersFormatter(hours)}:${numbersFormatter(minutes)}`;
}

function toDate(date: string, time = "12:00:00") {
  let [year, month, day] = date.split("-");
  let [hours, minutes, seconds] = time.split(":");

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(seconds)
  );
}

function dayTitle(date: Date) {
  return date.toLocaleDateString("fa-IR", {
    weekday: "long",
  });
}
